import React from 'react';

import { Select } from '../Select/Select';
import { useSvpCategories } from '../../../hooks/useSvpCategories';

import type { FC } from 'react';
import type { Option } from '../Select/Select';

type Props = {
  params?: Record<string, string>;
  label: string;
  name: string;
  allowEmpty?: boolean;
  disabled?: boolean;
  size?: 'big' | 'small' | 'compact';
  className?: string;
  onChange?: (option?: Option | Option[]) => Promise<void>;
};

export const CategoriesSelect: FC<Props> = ({ params = {}, ...props }) => {
  const { data: categories = [], isLoading } = useSvpCategories(params);

  const options = categories
    .filter(({ showCategory }) => !!showCategory)
    .map(({ id, title }) => ({
      value: id.toString(),
      label: `${title} (${id})`,
    }));

  return <Select {...props} options={options} isLoading={isLoading} />;
};
